<template>
  <div :style="info.wrap_style" :class="comp_wrap_class">
    <Title v-if="show_title && info.title" :config="info.config" :info="info.title" :parent_name="info.act_name_chn" />
    <slot></slot>
    <div v-if="show_title && info.title.show_divider" class="wrap_divider"></div>
  </div>
</template>
<script>
import click_handler from "../../tools/mgtv/click";
import { openLink } from "../../tools/mgtv/link";
import Title from "./Title";

export default {
  name: "NzmWrap",
  components: { Title },
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          act_name: "act_name",
          act_name_chn: "图标组件",
          wrap_style: {
            paddingTop: "0px"
          },
          title: {
            show: true,
            title: "我是ICON的标题",
            show_divider: false,
            icon: "https://via.placeholder.com/64x32?text=ICON",
            more_url: "https://www.mgtv.com"
          }
        };
      }
    },
    wrap_class: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      show_title: false
    };
  },
  computed: {
    comp_wrap_class: function() {
      const preview_module_class = (gact.f_release === '0' && ( this.info.act_name === gact.preview_module)) ? 'preview_module' : '';
      return `component_wrap nzm_wrap_${this.info.act_name}_${this.info.comp_type} ${this.wrap_class} ${preview_module_class}` ;
    }
  },
  mounted(){
    //避免标题在图片展示前就出现
    setTimeout(()=>{
      this.show_title = true;
    },500);
  }
};
</script>


<style lang="stylus" scoped>
.component_wrap
  position relative
  width 7.5rem
  @media screen and (min-width: 700px)
    margin-bottom 10PX !important
  .wrap_divider
    height .1rem
    width 7.5rem
    background rgba(0,0,0,.1)
    margin-top .2rem
.preview_module
  border 2px solid red

</style>
